// extracted by css-extract-rspack-plugin
export default {"container":"NofKy","title":"Lpi31","body":"A6WEm"};